import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import '../Registration.css';
import './Schedule.css';
import { host } from '../../App';
import { UserOutlined, LogoutOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Menu, Dropdown, Modal } from 'antd';
import { Link } from "react-router-dom";
import { format } from 'date-fns';
import { LocalFireDepartment } from '@mui/icons-material';
function ManualSchedule(props) {
  var token = (window.localStorage.getItem("acessToken"));
  const user = JSON.parse(window.localStorage.getItem("Name"));

  // declare all variables in order to send to js file
  var [shift, setShift] = useState("Morning_Operators");
  var [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [Morning_operators, setMorning_operators] = useState([]);
  const [Machine_list, setMachine_list] = useState([]);
  const [part_dataset, setpart_dataset] = useState([]);
  const [Area, setArea] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // NEW: tracks which row indexes are missing a required field
  const [rowErrors, setRowErrors] = useState({});
  // NEW: controls the "review before submit" modal
  const [isReviewOpen, setIsReviewOpen] = useState(false);
  // NEW: holds the exact rows that will be sent to the server, shown inside the review modal
  const [reviewRows, setReviewRows] = useState([]);

  const getCurrentDate = () => {
    return new Date().toISOString().split('T')[0]; // Get current date in 'YYYY-MM-DD' format
  };

  const defaultData = () => {
    const Date2 = getCurrentDate();
    return [
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
      { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' }
    ];
  };

  // Initial empty state
  const [data, setData] = useState(defaultData);

  // Retrieve from localStorage on first render
  useEffect(() => {
    const savedData = window.localStorage.getItem('data');

    setTimeout(() => {
      if (savedData) {
        setData(JSON.parse(savedData));  // Set the data after loading
      }
    }, 1000)
  }, []); // Empty dependency array ensures this runs once on mount


  // Save data to localStorage whenever 'data' state changes
  const saveDraft = () => {
    try {

      window.localStorage.setItem('data', JSON.stringify(data));
    } catch (error) {

    }
  };


  const queryParams = {
    shift: shift,
    token: token,
    Date: Date2,
    user: user,
    Department: Area
  };
  // Hook to update the date as today's date
  useEffect(() => {
    const timer = setInterval(() => {
      setDate1(new Date(), 10);
    }, 1000); // Update every second

    return () => clearInterval(timer); // Cleanup on component unmount
  }, []);

  useEffect(() => {
    if (shift.length > 1) {
      Axios.get(`https://` + host + `/api/employees`, { params: queryParams })
        .then((data) => {
          const filteredEmployees = data.data.filter((employee) => employee.Name && employee.Name.length > 1);
          setMorning_operators(filteredEmployees);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
  }, [shift]);

  // to retreive Machines
  useEffect(() => {
    Axios.get(`https://` + host + `/realapi/get/Machines/${token}`).then((data) => {
      setMachine_list(data.data)
    });
  }, [])
  // to retreive Machines
  useEffect(() => {
    Axios.get(`https://` + host + `/realapi/get/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data)
    });
  }, [])

  // select rigid/flex or all parts
  const area = () => {

    if (Area == "Rigid") {
      console.log("rigid called");
      Axios.get(`https://` + host + `/realapi/get/Rigidpart_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
      });
      Axios.get(`https://` + host + `/realapi/get/RigidMachines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
    if (Area == "Flex") {
      Axios.get(`https://` + host + `/realapi/get/Flexpart_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
      });
      Axios.get(`https://` + host + `/realapi/get/FlexMachines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
    if (Area == "Others") {
      Axios.get(`https://` + host + `/realapi/get/part_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
        console.log(data.data);

      });
      Axios.get(`https://` + host + `/realapi/get/Machines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
  }
  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
  }, [Date2])

  const submitValue = (e, index) => {
    const value = e.target.value.trim().replace(/\s+/g, ' ');
    const partDetails = part_dataset.find(
      (x) => x.Part_internalNo.trim().replace(/\s+/g, ' ') === value
    );

    if (!partDetails) {
      console.warn("No part found for:", value);
      return;
    }

    const newData = [...data];
    newData[index].Part_internalNo = value;
    newData[index].Customer = partDetails.Customer;
    newData[index].PartNo = partDetails.PartNo;
    newData[index].Part_description = partDetails.Part_description;

    setData(newData);
    saveDraft();
  };
  const addLines = () => {
    if (data.length < 15) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({ Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Supervisor_notes: '', Operator_2: '' });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit")
    }

  }
  const addNewRow = (index, operatorName, work_station) => {
    const newData = [...data];
    const newRow = { Operator: operatorName, Part_internalNo: '', Customer: '', PartNo: '', Part_description: '', Target: '', work_station: work_station, Operator_2: '', Supervisor_notes: '' };
    newData.splice(index + 1, 0, newRow);
    setData(newData);
  };
  useEffect(() => {
    const initialData = Morning_operators.map((operator, idx) => ({
      id: idx + 1, // Add a unique key for each initial row
      Operator: operator.Name,
      Part_internalNo: '',
      Customer: '',
      PartNo: '',
      Part_description: '',
      Target: '',
      work_station: '',
      Operator_2: '',
      Supervisor_notes: ''
    }));
    setData(initialData);
  }, [Morning_operators]);

  const handleLogout = () => {
    window.localStorage.removeItem("acessToken");
    window.localStorage.removeItem("Name");
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    props.history.push('/');
  }
  const userMenu = (
    <Menu>
      <Menu.Item key="logout">
        <a onClick={handleLogout} href="/">
          <LogoutOutlined />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  // NEW: Operator and Work Station can arrive already filled in on a row without the
  // user actually working that row — either because the "Add {Operator}" button copies
  // both from the row above, or because the initial employee list load pre-fills
  // Operator for every row. So a row only counts as "started" (and therefore worth
  // validating) once it has something in a field that ISN'T part of that auto-fill:
  // the selected Part, Target, Operator-2, or Supervisor Notes.
  const isRowStarted = (item) => {
    return !!(item.Part_internalNo || item.Target || item.Operator_2 || item.Supervisor_notes);
  }

  // NEW: required checkpoints are Operator, Work Station, Target, AND Part selection.
  // Only enforced once the row is actually "started" per isRowStarted above, so a row
  // that merely inherited Operator/Work Station never turns red on its own.
  const isRowInvalid = (item) => {
    return isRowStarted(item) && (!item.Operator || !item.work_station || !item.Target || !item.Part_internalNo);
  }

  // NEW: walks every row, marks the invalid ones so they render red, returns whether the whole form is OK
  const validateRows = () => {
    const errors = {};
    let hasError = false;
    data.forEach((item, index) => {
      if (isRowInvalid(item)) {
        errors[index] = true;
        hasError = true;
      }
    });
    setRowErrors(errors);
    return !hasError;
  }

  // NEW: builds a readable "what's missing" message for a given row
  const missingFieldsLabel = (item) => {
    return [
      !item.Operator ? "Operator" : null,
      !item.work_station ? "Work Station" : null,
      !item.Target ? "Target" : null,
      !item.Part_internalNo ? "Part Selection" : null
    ].filter(Boolean).join(", ");
  }

  // MODIFIED: this used to fire the Axios POST directly. Now it validates the rows,
  // and if everything required is filled in, it opens a review modal instead of submitting straight away.
  const submitdata = () => {
    const formIsValid = validateRows();

    if (!formIsValid) {
      window.alert("Some rows are missing Operator, Work Station, Target or a selected Part. Those rows are highlighted in red — please complete or clear them before submitting.");
      return;
    }

    const rowsReadyToSubmit = data.filter(item =>
      item.Operator &&
      item.Part_internalNo &&
      item.PartNo &&
      item.Customer &&
      item.Part_description
    );

    if (rowsReadyToSubmit.length === 0) {
      window.alert("There is nothing to submit yet. Please fill in at least one complete row.");
      return;
    }

    setReviewRows(rowsReadyToSubmit);
    setIsReviewOpen(true);
  }

  // NEW: this is what actually posts to the server, only called once the user confirms inside the review modal
  const confirmFinalSubmit = () => {
    const filteredData = reviewRows.map(item => ([
      Date2,
      item.Operator,
      item.Part_internalNo,
      item.PartNo,
      item.Customer,
      item.Part_description,
      item.Target,
      item.work_station,
      item.Supervisor_notes,
      item.Operator_2,
      user,
      getFormattedDateTime(Date1),
      shift
    ]));

    setIsReviewOpen(false);
    setIsLoading(true);
    setTimeout(() => {
      Axios.post(`https://` + host + `/realapi/Schedule_entry`, { filteredData, token }).then((response) => {
        if (response.status === 200) {
          window.alert(response.data.message);
          // window.localStorage.removeItem("data");
          setIsLoading(false);
          window.location.reload();

        }
      })
        .catch(error => {
          window.alert("Error Occured")
          setIsLoading(false);
        });
    }, 2000)

  }

  const getFormattedDateTime = (date) => {
    return format(date, 'yyyy-MM-dd HH:mm:ss');
  };

  let lastOperator = '';  // To track the last operator seen
  let lastColor = 'light';  // To track the last color used ('light' or 'dark')

  const getStripedClass = (currentOperator) => {
    if (currentOperator !== lastOperator) {
      // If the operator has changed, toggle the color
      lastColor = lastColor === 'light' ? 'dark' : 'light';
      lastOperator = currentOperator;
    }
    return lastColor;
  };
  const print = () => {
    console.log(part_dataset)
  }
  return (
    <div className="production-entry-page">
      <br></br>
      {/* <button onClick={print}>Print</button>*/}
      <h1>CREATE NEW SCHEDULE</h1>
      <br></br>
      <div className="row">
        <div className="col-2" >
          <label><b>
            <h4> Select Shift</h4>
          </b></label>
          <div className="row">
            <select
              name="shift"
              className="form-control form-rounded"
              placeholder="Select Shift"
              value={shift}
              onChange={(e) => { setShift(e.target.value) }}
            > <option value="Morning_Operators', 'Night_Operators', 'Woodshop">All Employees</option>
              <option value="Morning_Operators">1st Shift</option>
              <option value="Night_Operators">2nd Shift</option>
              <option value="Woodshop">Woodshop/Upholstery</option>
            </select>
          </div>
        </div>

        <div className="col-2">
          <label><b>
            <h4> Select Department</h4>
          </b></label>
          <select type="select" className="form-control form-rounded" id='Area' placeholder="Area" onChange={(e) => {
            setArea(e.target.value)
          }} onClick={area} onKeyDown={area} name="area"
          > <option value="Others">Others</option>
            <option value="Flex">Flex</option>
            <option value="Rigid">Rigid</option>
          </select>
        </div>

        <div className="col-2">
          <label><b>
            <h4>Date</h4>
          </b></label>
          <input type="date" className="form-control form-rounded" placeholder="Date" name="Date" id='date' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => {
            setDate2(e.target.value)
          }} required />
        </div>

        <div className="col-2">
          <label><b>
            <h4>Reset Schedule</h4>
          </b></label>
          <input type="button" className="form-control form-rounded" onClick={(e) => {
            window.localStorage.removeItem("data");
            window.alert("Cleared !");
          }} value="Clear All" />

        </div>



      </div>
      <br></br>
      <br></br>

      {/* MODIFIED: the old per-row Bootstrap col layout is replaced with an actual
          <table>, reusing the same production-entry-table styling as the Production
          Entry page. Same fields, same onChange/onBlur handlers, same per-row
          "Add" button — just laid out in aligned columns with a sticky header. */}
      <div className="production-table-wrapper">
        <table className="production-entry-table">
          <thead>
            <tr>
              <th className="col-operator">Operator</th>
              <th className="col-internal-part">Internal Part No</th>
              <th className="col-target">Target</th>
              <th className="col-workstation">Work Station</th>
              <th className="col-operator2">Operator 2</th>
              <th className="col-notes">Supervisor Notes</th>
              <th className="col-add">Add</th>
            </tr>
          </thead>
          <tbody>
            {data.map((line, index) => {
              const stripClass = getStripedClass(line.Operator);
              const rowClassName = [stripClass, rowErrors[index] ? "production-row-invalid" : ""].filter(Boolean).join(" ");

              return (
                <React.Fragment key={index}>
                  <tr className={rowClassName}>
                    <td className="col-operator">
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onChange={(e) => {
                          const newData = [...data];
                          newData[index].Operator = e.target.value;
                          setData(newData);
                        }}
                        onBlur={saveDraft}
                        list="operatorList"
                        value={line.Operator}
                        placeholder="Enter Operator"
                      />
                    </td>
                    <td className="col-internal-part">
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onChange={(e) => {
                          const newData = [...data];
                          newData[index].Part_internalNo = e.target.value;
                          setData(newData);
                        }}
                        onBlur={(e) => submitValue(e, index)} // Call the submitValue function on blur
                        value={data[index].Part_internalNo}
                        list="InternalPartNo"
                        placeholder="Enter Internal Part No"
                      />
                    </td>
                    <td className="col-target">
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onChange={(e) => {
                          if (!/^\d*$/.test(e.target.value)) {
                            alert("Numbers only");
                            return;
                          }
                          const newData = [...data];
                          newData[index].Target = e.target.value;
                          setData(newData);
                        }}
                        onBlur={saveDraft}
                        value={data[index].Target}
                        placeholder="Target"
                        name="target"
                        required
                      />
                    </td>
                    <td className="col-workstation">
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onChange={(e) => {
                          const newData = [...data];
                          newData[index].work_station = e.target.value;
                          setData(newData);
                        }}
                        onBlur={saveDraft}
                        placeholder="Work Station"
                        value={line.work_station}
                        list="Work_station"
                      />
                    </td>
                    <td className="col-operator2">
                      <input
                        type="text"
                        className="form-control form-rounded"
                        onChange={(e) => {
                          const newData = [...data];
                          newData[index].Operator_2 = e.target.value;
                          setData(newData);
                        }}
                        onBlur={saveDraft}
                        value={data[index].Operator_2}
                        placeholder="Operator-2 (Optional)"
                        name="operator_2"
                        list="operatorList"
                      />
                    </td>
                    <td className="col-notes">
                      <textarea
                        className="form-control form-rounded"
                        onChange={(e) => {
                          const newData = [...data];
                          newData[index].Supervisor_notes = e.target.value;
                          setData(newData);
                        }}
                        onBlur={saveDraft}
                        placeholder="Supervisor Notes"
                        name="Supervisor_notes"
                      />
                    </td>
                    <td className="col-add">
                      <button key={line.Operator} onClick={() => addNewRow(index, line.Operator, line.work_station)} className="form-control form-rounded">
                        Add {(line.Operator).split(0, 10)}
                      </button>
                    </td>
                  </tr>
                  {rowErrors[index] ? (
                    <tr className="production-row-error-tr">
                      <td colSpan={7}>
                        <ExclamationCircleOutlined /> Row {index + 1} is missing: {missingFieldsLabel(data[index])}
                      </td>
                    </tr>
                  ) : null}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* Shared datalists — kept once outside the table instead of re-rendered per row */}
      <datalist id="operatorList">
        <option key="empty-option"></option>
        {Morning_operators.map((x) => (
          <option key={x.Name}>{x.Name}</option>
        ))}
      </datalist>
      <datalist id="InternalPartNo">
        <option key="empty-option"></option>
        {part_dataset.map((x, idx) => (
          <option key={x.Part_internalNo + idx}>{x.Part_internalNo}</option>
        ))}
      </datalist>
      <datalist id="Work_station">
        <option key="empty-option"></option>
        {Machine_list.map((x, idx) => (
          <option key={x.Machines + idx}>{x.Machines}</option>
        ))}
      </datalist>

      <div className="production-actions">
        <button onClick={submitdata} className="btn btn-primary">Submit</button>
        <button onClick={addLines} className="btn btn-success">Add Row</button>
        <Link to="/RetrieveData">
          <button type="button" className="btn btn-success" >Read Table </button>
        </Link>
        <Link to="/ActivityLog">
          <button type="button" className="btn btn-warning" >Activity Log </button>
        </Link>
        <Link to="/Scheduling">
          <button type="button" className="btn btn-secondary" >Scheduling </button>
        </Link>
      </div>

      {/* Review-before-submit modal. Shows exactly what will be sent to the server. */}
      <Modal
        title="Review Schedule Entries Before Submitting"
        open={isReviewOpen}
        onCancel={() => setIsReviewOpen(false)}
        width="85vw"
        centered
        footer={[
          <Button key="back" onClick={() => setIsReviewOpen(false)}>
            Go Back &amp; Edit
          </Button>,
          <Button key="submit" type="primary" onClick={confirmFinalSubmit}>
            Confirm &amp; Submit
          </Button>
        ]}
        className="production-review-modal"
      >
        <p className="production-review-subtitle">
          {reviewRows.length} row{reviewRows.length !== 1 ? "s" : ""} will be submitted. Please review before confirming.
        </p>
        <div className="production-review-table-wrapper">
          <table className="production-review-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Operator</th>
                <th>Operator 2</th>
                <th>Internal Part No</th>
                <th>Description</th>
                <th>Target</th>
                <th>Work Station</th>
                <th>Supervisor Notes</th>
              </tr>
            </thead>
            <tbody>
              {reviewRows.map((item, i) => (
                <tr key={i}>
                  <td>{Date2}</td>
                  <td>{item.Operator}</td>
                  <td>{item.Operator_2}</td>
                  <td>{item.Part_internalNo}</td>
                  <td>{item.Part_description}</td>
                  <td>{item.Target}</td>
                  <td>{item.work_station}</td>
                  <td>{item.Supervisor_notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>

      {isLoading ?
        <div className='overlay'>
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div> : null}

    </div>
  )
}



export default ManualSchedule